import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      // Must match the cookie attributes the SSR middleware writes with, or the
      // browser stores a second host-only copy of every auth-token chunk under
      // the same name. The two copies then refresh independently and trip
      // Supabase refresh-token reuse detection, invalidating the session.
      cookieOptions: {
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN || undefined,
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'lax',
      },
    }
  )
}
